import React from 'react';
import SectionHeading from '../Typography/SectionHeading/SectionHeading';
import EditButton from '../Typography/EditButton/EditButton';
import { jointOwnerLine1, jointOwnerLine2 } from './util';
import styles from '../ReviewCombinedPersonalInformation/style.css';
import { accountTypes, customerTypes } from '../../flows/shared/utils';

const ReviewAdditionalCustomers = ({
  additionalCustomers,
  handleClick,
  hasMinors,
  accountType
}) => {
  return (
    <div className="review-customer-information">
      <div className="section-header">
        <SectionHeading
          text={`${hasMinors ? 'Minor' : 'Joint owner(s)'} information`}>
          <EditButton
            onClick={handleClick(
              `${
                accountType === accountTypes.UGMAUTMA ? 'minor' : 'joint-owners'
              }`
            )}
            currentlyEditing={false}
          />
        </SectionHeading>
      </div>

      {additionalCustomers
        .filter(owner =>
          hasMinors ? owner.customerType === customerTypes.MINOR : owner
        )
        .map(owner => {
          return (
            /* eslint-disable react/jsx-key */
            <div className="customer-information-lines">
              <div>{jointOwnerLine1(owner)}</div>
              <div className="nasu_masking_class">{jointOwnerLine2(owner)}</div>
            </div>
          );
        })}

      <style jsx>{styles}</style>
    </div>
  );
};

export default ReviewAdditionalCustomers;
